import React, { useState, useEffect } from "react";
import { reviewDetail } from "../../services/reviewServices";
import { useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";

const ViewReviewPageNew = () => {
  const { id } = useParams(); 
  const [item, setItem] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await reviewDetail(id);
      setItem(response?.data?.review || null);
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to fetch review detail");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchData();
  }, [id]);

  // ✅ Helper for formatting date
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}/${
      (date.getMonth() + 1).toString().padStart(2, "0")
    }/${date.getFullYear()}`;
  };

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {loading ? (
              <p>Loading...</p>
            ) : item ? (
              <>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <p>
                      <strong>Rating:</strong> {item.rating}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>User:</strong> {item?.userData?.fullName} 
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Event:</strong> {item?.eventData?.name}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Date:</strong> {formatDate(item.createdAt)}
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <p>
                      <strong>Review:</strong> {item.review}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <p>No data found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewReviewPageNew;
